import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotVideos() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门<span className="text-primary-500">视频</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">全网最热吃瓜内容，大家都在看</p>
          </div>
          <Link
            to="/category/mingxing-bagua"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={`黑料吃瓜视频 - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="flex items-center gap-1 text-white/90 text-xs bg-black/40 px-2 py-1 rounded-full">
                    <i className="ri-time-line"></i>
                    {article.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-bold">
                    HOT
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000
                      ? `${(article.views / 10000).toFixed(1)}万`
                      : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {article.comments}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/mingxing-bagua"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}